import { render, staticRenderFns } from "./RewardRatio.vue?vue&type=template&id=a54d0ef0&scoped=true&"
import script from "./RewardRatio.vue?vue&type=script&lang=ts&"
export * from "./RewardRatio.vue?vue&type=script&lang=ts&"
import style0 from "./RewardRatio.vue?vue&type=style&index=0&id=a54d0ef0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54d0ef0",
  null
  
)

export default component.exports